import * as React from "react";
import { StandardProps } from "@material-ui/core";
import MuiTableBody, {
    TableBodyClassKey as MuiTableBodyClassKey,
    TableBodyBaseProps as MuiTableBodyBaseProps
} from "@material-ui/core/TableBody";

export type TableBodyClassKey = MuiTableBodyClassKey;
export type TableBodyBaseProps = MuiTableBodyBaseProps;

export interface TableBodyProps extends StandardProps<TableBodyBaseProps, TableBodyClassKey> {
    component?: React.ReactType<TableBodyBaseProps>;
}

class TableBody extends React.Component<TableBodyProps>{

    render() {
        const { ...props } = this.props;

        return <MuiTableBody {...props}>
            {this.props.children}
        </MuiTableBody>
    }
}

export default TableBody;
